import { render, staticRenderFns } from "./ThsTradePanel.vue?vue&type=template&id=0dc584bd&scoped=true"
import script from "./ThsTradePanel.vue?vue&type=script&lang=js"
export * from "./ThsTradePanel.vue?vue&type=script&lang=js"
import style0 from "./ThsTradePanel.vue?vue&type=style&index=0&id=0dc584bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc584bd",
  null
  
)

export default component.exports